import FeatureFlags from '../constants/FeatureFlags';
import { CheckOutPages } from '../types/Common';

export default (page: CheckOutPages): string[] => {
  const generalItems = ['subtotal'];
  let specialItems = [] as string[];

  switch (page) {
    case 'cart':
      specialItems = [
        'coupon',
        'eventVcoin',
        'storageVcoin',
        'shippingFee',
        'totalPrice',
      ];
      break;
    case 'checkout':
      specialItems = [
        'coupon',
        'eventVcoin',
        'storageVcoin',
        'shippingFee',
        'paymentFee',
        'totalPrice',
      ];
      break;
    case 'payment':
      specialItems = [
        'coupon',
        'eventVcoin',
        'storageVcoin',
        'shippingFee',
        'paymentFee',
        'totalPrice',
      ];
      break;
    default:
      break;
  }

  if (FeatureFlags.CX_2444_OVERSEA_SHIPPING_FEE) {
    specialItems.splice(3, 0, 'crossBorderShippingFee');
  }

  generalItems.splice(1, 0, ...specialItems);

  return generalItems;
};
